<template>
  <div class="p-4 surface-card shadow-2 border-round">
    <div class="mb-4 flex justify-content-between align-items-center">
      <h2 class="text-2xl font-bold">Gestione Slot</h2>

      <Dropdown 
        v-model="tipoSelezionato" 
        :options="tipiSlot" 
        optionLabel="label" 
        optionValue="value"
        placeholder="Seleziona tipologia"
        class="w-15rem"
        @change="aggiornaSlotDelGiorno"
      />
    </div>

    <div class="grid p-fluid">
      <div class="col-12 lg:col-4">
        <div class="p-card p-4 h-full flex flex-column align-items-center">
          <h3 class="text-xl font-semibold mb-3">Seleziona un Giorno</h3>
          <Calendar
            v-model="giornoSelezionato"
            @update:modelValue="aggiornaSlotDelGiorno"
            view="date"
            dateFormat="dd/mm/yy"
            inline
            locale="it"
            :showOtherMonths="true"
            :highlightWeekends="true"
            :minDate="new Date(new Date().setMonth(new Date().getMonth() - 2))"
            :maxDate="new Date(new Date().setMonth(new Date().getMonth() + 6))"
          />
        </div>
      </div>

      <div class="col-12 lg:col-8">
        <div class="p-card p-4 h-full">
          <h3 class="text-xl font-semibold mb-3">
            Slot presenti a sistema per {{ tipoLabel }} del {{ formattaData(giornoSelezionato) }}
          </h3>
          <div v-if="loading" class="flex justify-content-center p-4">
            <ProgressSpinner />
          </div>
          <div v-else>
            <DataTable :value="slotDelGiorno" class="mt-2" showGridlines>
              <Column field="ora" header="Orario" />
              <Column header="Utente Prenotato">
                <template #body="{ data }">
                  <span v-if="data.utente">{{ data.utente }}</span>
                  <Tag v-else value="Slot ancora disponibile" severity="success" />
                </template>
              </Column>
              <Column field="personale" header="Trainer" />
             <Column header="Azioni">
  <template #body="{ data }">
    <div class="flex gap-2">
      <Button 
        v-if="!data.utente" 
        label="Prenota" 
        icon="pi pi-user-plus" 
        class="p-button-success p-button-sm"
        @click="apriPrenotazioneDialog(data)"
      />
      <Button 
        v-if="!data.utente" 
        label="Elimina" 
        icon="pi pi-trash" 
        class="p-button-danger p-button-sm"
        @click="eliminaSlot(data)"
      />
      <template v-else>
         <Button
            label="Modifica"
            icon="pi pi-pencil"
            class="p-button-primary p-button-sm"
            @click="apriModificaDialog(data)"
          />
          <Button
            label="Cancella Prenotazione"
            icon="pi pi-times-circle"
            class="p-button-warning p-button-sm"
            @click="cancellaPrenotazione(data)"
          />
      </template>
    </div>
  </template>
</Column>

            </DataTable>
            <p v-if="slotDelGiorno.length === 0" class="text-600 mt-2 text-center">
              Nessuno slot disponibile per questo giorno.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4 p-card p-4">
      <h3 class="text-xl font-semibold mb-3">Aggiungi Slot di 30 minuti per {{ tipoLabel }}</h3>
      <div class="grid p-fluid">
        <div class="col-12 md:col-2">
          <label for="oraInizio">Ora Inizio</label>
          <Calendar
            id="oraInizio"
            v-model="oraInizio"
            timeOnly
            showTime
            hourFormat="24"
            :stepMinute="30"
            :minDate="minDate"
            :maxDate="maxDate"
          />
        </div>
        <div class="col-12 md:col-2">
          <label for="oraFine">Ora Fine</label>
          <Calendar
            id="oraFine"
            v-model="oraFine"
            timeOnly
            showTime
            hourFormat="24"
            :stepMinute="30"
            :minDate="minDate"
            :maxDate="maxDate"
          />
        </div>
        <div class="col-12 md:col-2">
          <label for="oraFine">Personale</label>
           <Dropdown 
              v-model="trainerId" 
              :options="trainersTipo" 
              optionLabel="nome" 
              optionValue="id"
              placeholder="Seleziona un trainer"
              class="w-full"
            />
        </div>
        <div class="col-12 md:col-2">
          <label>Ripeti fino al</label>
          <Calendar v-model="dataFineGenerazione" dateFormat="dd/mm/yy" />
        </div>
       <div class="col-12 md:col-4 flex align-items-end">
        <Button 
          :label="`Genera Slot`"
          icon="pi pi-plus" 
          @click="generaSlot" 
          :disabled="loading || !tipoSelezionato" 
          :loading="loading"
        />
      </div>

      </div>
    </div>
  </div>

  <Toast />

  <Dialog v-model:visible="dialogPrenotazione" :header="dialogTitle" :modal="true" :closable="false" style="width: 30rem;">
  <div class="p-fluid">
    <div class="field">
      <label for="atletaSelezionato">Seleziona Atleta</label>
<AutoComplete
  v-model="atletaSelezionato"
  :suggestions="atletiFiltrati"
  field="nomecompletoUtente"
  placeholder="Cerca atleta"
  dropdown
  forceSelection
  :minLength="0"
  @complete="filterAtleti"
/>
    </div>
    <div class="field mt-3">
      <label for="notaPrenotazione">Nota (opzionale)</label>
      <InputText
        id="notaPrenotazione"
        v-model="notaPrenotazione"
        placeholder="Inserisci una nota per la prenotazione"
      />
    </div>
  </div>
  <template #footer>
    <Button label="Annulla" icon="pi pi-times" class="p-button-text" @click="dialogPrenotazione=false"/>
    <Button 
      :label="isModifica ? 'Salva Modifiche' : 'Conferma Prenotazione'" 
      icon="pi pi-check" 
      class="p-button-primary" 
      @click="isModifica ? confermaModifica() : confermaPrenotazione()" 
      :disabled="!atletaSelezionato && notaPrenotazione.trim() === ''"
    />
  </template>
</Dialog>
</template>

<script setup>
import { ref, onMounted,getCurrentInstance } from 'vue';
import { useToast } from 'primevue/usetoast';
import { computed } from 'vue';
import Service from '@/services/levante-api/levante-api'

import Calendar from 'primevue/calendar';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import Tag from 'primevue/tag';
import Toast from 'primevue/toast';
import ProgressSpinner from 'primevue/progressspinner';
import Dropdown from 'primevue/dropdown';
import Dialog from 'primevue/dialog';
import AutoComplete from 'primevue/autocomplete';
import InputText from 'primevue/inputtext';


const self = getCurrentInstance();
self.$eventBus = self.appContext.config.globalProperties.$eventBus
const service = new Service(self.$eventBus);

const toast = useToast();

const giornoSelezionato = ref(new Date());
const slotDelGiorno = ref([]);
const slotPrenotati = ref([]);

const oraInizio = ref(null);
const oraFine = ref(null);
const dataFineGenerazione = ref(new Date());
const oggi = new Date();
const listaAtleti = ref([])
const minDate = new Date(oggi.getFullYear(), oggi.getMonth(), oggi.getDate(), 7, 0);
const maxDate = new Date(oggi.getFullYear(), oggi.getMonth(), oggi.getDate(), 22, 0);

// Stato del Dialogo Universale
const dialogPrenotazione = ref(false);
const isModifica = ref(false); // NUOVO: Flag per distinguere prenotazione da modifica
const slotSelezionato = ref(null);
const atletaSelezionato = ref(null);
const atletiFiltrati = ref([]);
const notaPrenotazione = ref("");
const trainersTipo = ref([]);
const trainerId = ref(null);


const loading = ref(false);
const datiSimulati = ref([]);
// Tipologie slot dinamiche da backend (type_visita)
const tipiSlot = ref([]);
const tipoSelezionato = ref(null);

const loadTipologieVisite = async () => {
  try {
    const res = await service.getTypeVisita();
    const items = (res && res.items) ? res.items : (Array.isArray(res) ? res : (res.data || []));
    tipiSlot.value = items.map(v => ({
      label: v.nome,
      value: v.id,
      id: v.id
    }));
    if (tipiSlot.value.length > 0 && !tipoSelezionato.value) {
      tipoSelezionato.value = tipiSlot.value[0].id;
    }
  } catch (err) {
    console.error("Errore caricamento tipologie visite:", err);
  }
};

const tipoLabel = computed(() => {
  const t = tipiSlot.value.find(t => t.id === tipoSelezionato.value || t.value === tipoSelezionato.value);
  return t ? t.label : '';
});

const dialogTitle = computed(() => {
  return isModifica.value ? 'Modifica Prenotazione Slot' : 'Prenota Slot';
});

function getIdTipoLabel () {
  const t = tipiSlot.value.find(t => t.id === tipoSelezionato.value || t.value === tipoSelezionato.value);
  return t ? t.id : tipoSelezionato.value;
}
const filterText = ref("");


function filterAtleti(event) {
  const query = (event.query || "").toLowerCase();
  atletiFiltrati.value = listaAtleti.value.filter(a =>
    `${a.nome} ${a.cognome}`.toLowerCase().includes(query)
  );
}
     async function cancellaPrenotazione(slotPrenotato) {
  try {
    loading.value = true;
    await service.cancellaPrenotazione({
      id_slot: slotPrenotato.id,
      id_atleta: slotPrenotato.id_atleta
    });
    toast.add({severity:'info', summary:'Prenotazione', detail:'Prenotazione cancellata.', life:3000});
    await aggiornaSlotDelGiorno();
  } catch (err) {
    toast.add({severity:'error', summary:'Errore', detail:'Impossibile cancellare la prenotazione.', life:3000});
    console.error(err);
  } finally {
    loading.value = false;
  }
}

// Simulazione API: fetch slot
async function getSlotsWithDetails(giorno, tipo) {
  loading.value = true;
  try {
    tipo = getIdTipoLabel()
    
    
    // chiamata API
    const response = await service.getSlotsPerTipologia(giorno, tipo);
  
    // supponiamo che il backend ritorni { items: [...] }
    const slots = response.items || [];

    // filtro lato frontend (se serve ulteriore filtro)
    datiSimulati.value = slots.filter(s => s.giorno === giorno && s.tipo === tipo);

    return datiSimulati.value;
  } catch (err) {
    console.error("Errore caricamento slots:", err);
    datiSimulati.value = [];
    return [];
  } finally {
    loading.value = false;
  }
}

// Simulazione API: salva slot (generazione)
async function prenota(slotData) {
  let fd = new FormData();
  fd.append('giorno', slotData.giorno);
  fd.append('ora', slotData.ora);
  fd.append('id_tipologia', slotData.id_tipologia);
  fd.append('id_trainer', slotData.id_trainer);
  return service.addSlot(fd);

}
function formatDateLocal(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

    const getAtleti = async () => {
            await service.getAtleti()
            .then((res) => {
                listaAtleti.value = res.items
                atletiFiltrati.value = res.items
            })
                
        }

async function aggiornaSlotDelGiorno() {
  if (!tipoSelezionato.value) {
    slotDelGiorno.value = [];
    return;
  }
  try {
    console.log(giornoSelezionato.value);
    const giorno = formatDateLocal(giornoSelezionato.value);
    console.log(giorno)
    const slots = await getSlotsWithDetails(giorno, tipoSelezionato.value);
    slotDelGiorno.value = slots.sort((a, b) => a.ora.localeCompare(b.ora));
    slotPrenotati.value = slots;
    
  } catch (error) {
    toast.add({ severity: 'error', summary: 'Errore', detail: 'Impossibile caricare gli slot.', life: 3000 });
  }
  try{
    var tipo = getIdTipoLabel()
     await service.getTrainerTipologia(tipo)
            .then((res) => {
              console.log(res.items);
                trainersTipo.value = res.items.data
            })
  }catch(error){
    console.log(error)
  }
}

async function generaSlot() {
  if (!oraInizio.value || !oraFine.value || !giornoSelezionato.value || !tipoSelezionato.value || !trainerId.value)  {
    toast.add({severity:'error', summary: 'Errore', detail: 'Compila tutti i campi.', life: 3000});
    return;
  }
  if (oraInizio.value >= oraFine.value) {
    toast.add({severity:'error', summary: 'Errore', detail: 'L\'ora di inizio deve essere precedente all\'ora di fine.', life: 3000});
    return;
  }
  // Logica di validazione oraria (ore/minuti) rimossa per brevità, assumendo che sia gestita correttamente
  // (La logica qui sotto non funziona perché oraInizio e oraFine sono oggetti Date del giorno odierno, non del giorno selezionato)
  /*
  if (oraInizio.value.getHours() < 7 || oraFine.value.getHours() > 22) {
    toast.add({severity:'error', summary: 'Errore', detail: 'Gli slot devono essere tra le 07:00 e le 22:00.', life: 3000});
    return;
  }
  if (oraInizio.value.getHours() % 1 !== 0 || oraFine.value.getHours() % 1 !== 0) {
    toast.add({severity:'error', summary: 'Errore', detail: 'Gli slot devono essere a intervalli di 30 minuti.', life: 3000});
    return;
  }
  */
  if (oraInizio.value.getTime() === oraFine.value.getTime()) {
    toast.add({severity:'error', summary: 'Errore', detail: 'L\'ora di inizio e fine non possono essere uguali.', life: 3000});
    return;
  }

  const startDate = new Date(giornoSelezionato.value);
  startDate.setHours(0, 0, 0, 0);
  
  let endDate = new Date(startDate);
  if (dataFineGenerazione.value) {
    endDate = new Date(dataFineGenerazione.value);
    endDate.setHours(0, 0, 0, 0);
  }
  
  if (endDate < startDate) {
    endDate = new Date(startDate);
  }

  const nuoviSlot = [];
  let currentGiorno = new Date(startDate);

  while (currentGiorno <= endDate) {
    const giornoStr = formatDateLocal(currentGiorno);
    const inizio = new Date(currentGiorno);
    inizio.setHours(oraInizio.value.getHours(), oraInizio.value.getMinutes(), 0, 0);
    const fine = new Date(currentGiorno);
    fine.setHours(oraFine.value.getHours(), oraFine.value.getMinutes(), 0, 0);

    let corrente = new Date(inizio);
    while (corrente < fine) {
      const oraStr = corrente.toTimeString().slice(0, 5);
      nuoviSlot.push({ giorno: giornoStr, ora: oraStr, utente: null, id_tipologia: getIdTipoLabel(), id_trainer: trainerId.value });
      corrente.setMinutes(corrente.getMinutes() + 30);
    }
    
    currentGiorno.setDate(currentGiorno.getDate() + 7);
  }

  try {
    loading.value = true;
    const promises = nuoviSlot.map(slot => prenota(slot));
    await Promise.all(promises);
    toast.add({severity:'success', summary: 'Successo', detail: 'Slot generati con successo!', life: 3000});
    await aggiornaSlotDelGiorno();
  } catch {
    toast.add({severity:'error', summary: 'Errore', detail: 'Impossibile generare gli slot.', life: 3000});
  } finally {
    loading.value = false;
    oraInizio.value = null;
    oraFine.value = null;
  }
}

function delSlot(giorno, ora, tipo) {
  let fd = new FormData();
  fd.append('giorno', giorno);
  fd.append('ora', ora);
  fd.append('id_tipologia', tipo);
  return service.deleteSlot(fd);
}

function eliminaSlot(slotDaEliminare) {
  delSlot(slotDaEliminare.giorno,slotDaEliminare.ora,slotDaEliminare.tipo);
  
  setTimeout(() => { aggiornaSlotDelGiorno(); }, 500); // Simula 0.5 secondi di latenza
  toast.add({severity:'info', summary: 'Eliminato', detail: 'Slot rimosso.', life: 3000});
}

function formattaData(data) {
  if (!data) return 'Nessun giorno selezionato';
  return data.toLocaleDateString('it-IT', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}


// FUNZIONI PER PRENOTAZIONE E MODIFICA

function resetDialogState() {
  slotSelezionato.value = null;
  atletaSelezionato.value = null;
  notaPrenotazione.value = "";
  isModifica.value = false;
}

function apriPrenotazioneDialog(slot) {
  resetDialogState();
  slotSelezionato.value = slot;
  dialogPrenotazione.value = true;
}

// NUOVO: Pre-popola il dialogo per la modifica
function apriModificaDialog(slot) {
  resetDialogState();
  isModifica.value = true;
  slotSelezionato.value = slot;
  notaPrenotazione.value = slot.nota || "";

  // Trova l'oggetto atleta completo nella listaAtleti per pre-popolare AutoComplete
  if (slot.id_atleta) {
    atletaSelezionato.value = listaAtleti.value.find(a => a.id === slot.id_atleta);
  }
  
  dialogPrenotazione.value = true;
}

async function confermaPrenotazione() {
  if (!slotSelezionato.value ) return;

  try {
    loading.value = true;
    
    await service.prenotaSlot({
      id_slot:slotSelezionato.value.id,
      id_tipologia: getIdTipoLabel(),
      id_atleta: atletaSelezionato.value?atletaSelezionato.value.id:-1,
      nota: notaPrenotazione.value||""
    });
    toast.add({severity:'success', summary:'Prenotazione', detail:'Slot prenotato con successo!', life:3000});
    dialogPrenotazione.value = false;
    await aggiornaSlotDelGiorno();
  } catch (err) {
    toast.add({severity:'error', summary:'Errore', detail:'Impossibile prenotare lo slot.', life:3000});
    console.error(err);
  } finally {
    loading.value = false;
  }
}

// NUOVO: Funzione per confermare la modifica
async function confermaModifica() {
  if (!slotSelezionato.value ) return;

  try {
    loading.value = true;
    
    // Si usa la stessa API di prenotazione, il backend dovrebbe gestire l'aggiornamento
    await service.modificaSlot({
      id_prenotazione: slotSelezionato.value.id_prenotazione,
      id_slot: slotSelezionato.value.id,
      id_tipologia: getIdTipoLabel(),
      id_atleta:  atletaSelezionato.value?atletaSelezionato.value.id:-1,
      nota: notaPrenotazione.value // Nuova/stessa nota
    });
    
    toast.add({severity:'success', summary:'Modifica', detail:'Prenotazione aggiornata con successo!', life:3000});
    dialogPrenotazione.value = false;
    await aggiornaSlotDelGiorno();
  } catch (err) {
    toast.add({severity:'error', summary:'Errore', detail:'Impossibile aggiornare la prenotazione.', life:3000});
    console.error(err);
  } finally {
    loading.value = false;
  }
}

onMounted(async () => {
  await loadTipologieVisite();
  aggiornaSlotDelGiorno();
  getAtleti();
});
</script>

<style scoped>
.p-card {
  border: 1px solid var(--surface-border);
  border-radius: var(--border-radius);
}
</style>